import { render, staticRenderFns } from "./ListadoEntregas.vue?vue&type=template&id=75127e20"
import script from "./ListadoEntregas.vue?vue&type=script&lang=js"
export * from "./ListadoEntregas.vue?vue&type=script&lang=js"
import style0 from "./ListadoEntregas.vue?vue&type=style&index=0&id=75127e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports